import { cn } from "@/lib/utils";

const SEVERITY = {
  green: {
    bg: "bg-severity-green-bg",
    border: "border-severity-green/40",
    dot: "bg-severity-green",
    label: "\uD83D\uDFE2 Pas urgent",
  },
  yellow: {
    bg: "bg-severity-yellow-bg",
    border: "border-severity-yellow/40",
    dot: "bg-severity-yellow",
    label: "\uD83D\uDFE1 A surveiller",
  },
  red: {
    bg: "bg-severity-red-bg",
    border: "border-severity-red/40",
    dot: "bg-severity-red",
    label: "\uD83D\uDD34 Urgent",
  },
};

export default function SeverityBadge({ level, severity, className }) {
  const sev = SEVERITY[severity || level];
  if (!sev) return null;

  return (
    <div
      className={cn(
        "inline-flex items-center gap-1.5 px-3 py-1.5 rounded-xl border animate-fade-in",
        sev.bg,
        sev.border,
        className
      )}
    >
      <div className={cn("w-2 h-2 rounded-full shrink-0", sev.dot)} />
      <span className="text-xs font-extrabold" style={{ color: sev.dot.replace("bg-", "") }}>
        {sev.label}
      </span>
    </div>
  );
}
